import React, { Fragment } from "react"
import PropTypes from "prop-types"
import _capitalize from "lodash/capitalize"
import _map from "lodash/map"

import ItemBody from "./ItemBody"
import IncidentDownloadContextMenu from "../IncidentDownloadContextMenu"

const CompletedRequests = ({
  t,
  completedDemands,
  getDescription,
  onShowDetailsCompleted,
  onDownload,
  onSendMail,
  loading,
  onAudioRequestModal
}) => {
  return (
    <Fragment>
      {!loading &&
        completedDemands.length > 0 &&
        _map(completedDemands, (demand) => (
          <ItemBody
            key={demand.requestId}
            protocol={demand.protocolNumber}
            description={_capitalize(getDescription(demand))}
            onClickItem={() =>
              onShowDetailsCompleted(demand, "isOpenModalDetail")
            }
            type="completed"
            t={t}
            renderOthersColumns={() => (
              <td>
                <IncidentDownloadContextMenu
                  onDownload={() => onDownload(demand.protocolNumber)}
                  onSendMail={() => onSendMail(demand.protocolNumber)}
                  onAudioRequestModal={() => onAudioRequestModal(demand)}
                />
              </td>
            )}
          />
        ))}
    </Fragment>
  )
}

CompletedRequests.propTypes = {
  t: PropTypes.func,
  completedDemands: PropTypes.array,
  getDescription: PropTypes.array,
  onShowDetailsCompleted: PropTypes.func,
  onDownload: PropTypes.func,
  onSendMail: PropTypes.func,
  loading: PropTypes.bool,
  onAudioRequestModal: PropTypes.func
}

export default CompletedRequests



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/components/Requests/CompletedRequests.js